export default {	

	fr: {
		tooltip: {
			one: "jour", 
			other: "jours"
		},
		buttons: {
			apply: "Appliquer",
			cancel: "Annuler",
			previousMonth: "Prec.",
			nextMonth: "Suiv.", 
			reset: "Reset"
		},
	},

	en: {
		tooltip: {
			one: "day", 
			other: "days"
		},
		buttons: {
			apply: "Apply",
			cancel: "Cancel",
			previousMonth: "Prev",
			nextMonth: "Next", 
			reset: "Reset"
		},
	}

}